import styled from 'styled-components'
import { desktopMenuItemStyles } from './DesktopMenuItemStyles'
import { fadeInStyles } from './FadeInStyles'

export const UnderlinedMenuLink = styled.a`
  ${desktopMenuItemStyles}
  display: block;
  font-weight: 500;
  ${fadeInStyles}
`

export const MenuLink = styled(UnderlinedMenuLink)`
  text-decoration: none;
  font-weight: unset;
`

export const UnstyledLink = styled.a`
  color: unset;
  text-decoration: none;
`
